// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6cd9c6b","453":"a6e71465","455":"ca4e8f35","977":"8605720c"}[chunkId] + ".chunk.js";
};